import React from "react";
import { Row, Col, Nav } from "reactstrap";
import { Page } from "components/common";
import { HoverCard } from "components";
import img3 from "../../../assets/images/allowancerules-icon.svg";
import img8 from "../../../assets/images/publicholidays.svg";
import img11 from "../../../assets/images/deductions-icon.svg";
import BackButton from 'components/refactoring/BackButton';

const SettingsManagement = ({ match, t }) => {

  return (
    <div className="holder">
      <BackButton/>
      <Page title={t("Task Management Settings")} className="general-settings">
        <hr />
        <div>
        <Row>
          <Nav className="w-100">
            <Col md={6}>
              <HoverCard
                imgSrc={img8}
                to={`/tasks/re-assign-requests`}
                title="Re Assign Requests"
                description={t("Manage re-assign requests requested by the employees.")}
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={img3}
                to={`/tasks/groups`}
                title="Groups"
                description={t("Manage groups to add the employees and to assign it to the tasks.")}
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={img11}
                to={`/tasks/labels`}
                title="Labels"
                description={t("Manage task labels.")}
              />
            </Col>
          </Nav>
        </Row>
        </div>
      </Page>
    </div>
  );
};

export default SettingsManagement;
